import React, { Component } from "react";
import { observer } from "mobx-react";

import { IStreamCurrentValue } from "@formant/core/model/IStreamCurrentValue";
import { Uuid } from "@formant/core/model/Uuid";

import { PulseItem } from "./PulseItem";

export interface IPulseMetricProps {
    deviceId: Uuid;
    label: string;
    valueSuffix?: string;
    streamName: string;
    streamType: "battery" | "numeric set";
    min: number;
    max: number;
    currentData: IStreamCurrentValue[];
}

@observer
export class PulseMetric extends Component<IPulseMetricProps> {
    public render() {
        const { label, valueSuffix, streamName, streamType, currentData } =
            this.props;

        const latestData = currentData.find(_ => _.streamName === streamName);
        let value: number | undefined;

        if (latestData !== undefined) {
            switch (streamType) {
                case "battery":
                    value = (latestData as IStreamCurrentValue<"battery">)
                        .currentValue.percentage;
                    break;
                case "numeric set":
                    value = (
                        latestData as IStreamCurrentValue<"numeric set">
                    ).currentValue.find(_ => _.unit === "%")?.value;
                    break;
                default:
                    value = undefined;
                    break;
            }
        }

        const invertedWarning = streamType === "battery";

        return (
            <PulseItem
                label={label}
                valueSuffix={valueSuffix}
                value={value}
                invertedWarning={invertedWarning}
            />
        );
    }
}
